import moment from 'moment'

export default (type, data = []) => {
  return data
    .filter(item => {
      return type === 'less' ? moment(item.day) <= new Date() : moment(item.day) >= new Date()
    })
    .map(item => {
      return {
        x: moment(item.day).format('DD/MM/YYYY').toString(),
        y: item.value
      }
    })
}
